// Copyright (c) Docugami, Inc. All rights reserved.

import { IconButton, IOverflowSetItemProps, OverflowSet } from "@fluentui/react";
import { appContentColor, primaryTheme } from "components/shell/presentation/AppStyles";
import { ApiKey } from "networking/tokensApi";
import { useDeleteKeyMutation } from "store/apiKeys/apiKeysSlice";

interface ApiKeyOverflowMenuProps {
    apiKey: ApiKey;
}

export const ApiKeyOverflowMenu = (props: ApiKeyOverflowMenuProps): JSX.Element | null => {
    const [triggerDeleteKey, deleteKeyStatus] = useDeleteKeyMutation();

    function onRenderOverflowButton(overflowItems: any[] | undefined): JSX.Element {
        return (
            <IconButton
                iconProps={{ iconName: "More" }}
                styles={{
                    root: {
                        height: "16px"
                    },
                    icon: {
                        fontSize: '14px',
                        margin: 0,
                        color: appContentColor
                    },
                    rootHovered: { backgroundColor: primaryTheme.palette.neutralLighterAlt }
                }}
                menuProps={{ items: overflowItems!, styles: { root: { backgroundColor: primaryTheme.palette.white } } }}
                onRenderMenuIcon={() => null} />
        )
    }

    const overflowItems: IOverflowSetItemProps[] = [
        {
            key: "delete",
            name: "Delete",
            disabled: deleteKeyStatus.isLoading,
            onClick: () => triggerDeleteKey(props.apiKey.id)
        }
    ];

    return <OverflowSet overflowItems={overflowItems} onRenderItem={() => null} onRenderOverflowButton={onRenderOverflowButton} />
}
